import type { GuestListEntry as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/** A named guest on a guest list, admitted up to `quantity`. */
export type GuestListEntry = {
  id: number;
  guestListId: number;
  firstName: string;
  lastName: string;
  quantity: number;
  /** Read-only: admissions already claimed at the door. */
  claimed: number;
};

export const fromGql = (item: GQLItem): GuestListEntry =>
  take<GuestListEntry>(item, 'id', 'guestListId', 'firstName', 'lastName', 'quantity', 'claimed');
